'use client';

import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ResultFailure, ResultServerAction, ResultServerActionType } from '@headless-workspace/core-domain';
import useSWRMutation, { MutationFetcher, SWRMutationConfiguration } from 'swr/mutation';

const DEFAULT_ERROR_MESSAGE = 'An error occurred';

export const useSafeSWRMutation = <Data, ExtraArg>(
    validateKey: CacheKeys,
    actionName: ServerActionName,
    fetcher: MutationFetcher<ResultServerActionType<Data>, string, ExtraArg>,
    swrOptions?: SWRMutationConfiguration<ResultServerActionType<Data>, unknown, string, ExtraArg>,
) => {
    return useSWRMutation<ResultServerActionType<Data>, unknown, string, ExtraArg>(
        validateKey,
        async (_, { arg }) => {
            try {
                return await fetcher(validateKey, { arg });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : DEFAULT_ERROR_MESSAGE;
                return ResultServerAction(ResultFailure(actionName, errorMessage), actionName);
            }
        },
        swrOptions,
    );
};
